export default {"src":"/_next/static/media/PaymentMethodsDark.83a3170b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};